import { ChangeDetectionStrategy, Component, input, output } from "@angular/core";

import { SendFilterType } from "@bitwarden/common/tools/send/types/send-filter-type";
import { I18nPipe } from "@bitwarden/ui-common";

@Component({
  selector: "app-send-filters",
  templateUrl: "send-filters.component.html",
  imports: [I18nPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SendFiltersComponent {
  readonly selected = input<SendFilterType | undefined>(SendFilterType.All);
  readonly selectedChange = output<SendFilterType>();

  protected readonly sendFilterType = SendFilterType;

  protected onSelect(value: SendFilterType): void {
    this.selectedChange.emit(value);
  }
}
